import { ValidateEmailVerificationCodeArgs } from 'types/api/arguments/validate-email-verification-code-args'

import { api } from './api'

export const validateEmailVerificationCode = ({
  userId,
  code,
}: ValidateEmailVerificationCodeArgs) =>
  api.put(`/users/${userId}/verifications/email_code`, {
    code,
  })
